import type { LeaseRepresentation } from '@/common/types/interaction';
import type { MissingFieldsData } from '@/state/navigation';
import { computeMissingContactFields } from '../shared/missingFields';
import { buildContactsSchema } from '../shared/schema';
import type { ContactsFormData, ContactType } from '../shared/types';
import { getLeaseSideLabels, getRequiredContactFields } from './labels';

const roleLabels = (
  representation: LeaseRepresentation,
): Record<ContactType, string> => {
  const { own, counterparty } = getLeaseSideLabels(representation);
  return {
    agent: `${own}'s Agent`,
    client: own,
    counterpartyAgent: `${counterparty}'s Agent`,
    counterpartyTransactionCoordinator: `${counterparty}'s Transaction Coordinator`,
    counterpartyClient: counterparty,
    counterpartyAttorney: 'Attorney',
    titleOfficer: 'Title Officer',
    escrowOfficer: 'Escrow Officer',
    lender: 'Lender',
    appraiser: 'Appraiser',
    attorney: 'Attorney',
    closingAttorney: 'Closing Attorney',
    propertyManagingAgent: 'Property Managing Agent',
    homeWarranty: 'Home Warranty',
    other: 'Other Contact',
  };
};

export function computeMissingLeaseContactFields(
  formData: ContactsFormData,
  representation: LeaseRepresentation,
): MissingFieldsData[] {
  const schema = buildContactsSchema(getRequiredContactFields(representation));
  return computeMissingContactFields(formData, {
    schema,
    roleLabels: roleLabels(representation),
  });
}
